export const achievementData = {
    bio: "As a dedicated learner and professional, I have pursued various courses and certifications to enhance my skills and knowledge in different fields. From completing a Web Development Bootcamp and mastering Programming in Java to obtaining certifications in Data Structures and Cloud Computing, I've consistently sought to broaden my expertise. Additionally, I've expanded my horizons by passing the Japanese Language Proficiency Test (N5 level) and delving into networking with CCNA courses. My commitment to continuous learning reflects my passion for personal and professional growth.",
    achievements: [
        {
            id: 1,
            title: 'Web Development Bootcamp',
            details: 'Completed Web Development Bootcamp on Udemy in 2023.',
            date: '2023',
            field: 'Web Development',
            image: 'https://images.unsplash.com/photo-1573141597928-403fcee0e056?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=667&q=80'
        },
        {
            id: 2,
            title: 'Programming in Java',
            details: 'Completed Programming in Java course on NPTEL in 2023.',
            date: '2023',
            field: 'Java Programming',
            image: 'https://images.unsplash.com/photo-1523474253046-8cd2748b5fd2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
        },
        {
            id: 3,
            title: 'Data Structures',
            details: 'Completed Data Structures course on Coursera in 2023.',
            date: '2023',
            field: 'Data Structures',
            image: 'https://images.unsplash.com/photo-1489389944381-3471b5b30f04?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
        },
        // {
        //     id: 4,
        //     title: 'CCNA 1 and CCNA 2',
        //     details: 'Completed CCNA 1 and CCNA 2 courses with Cisco in 2024.',
        //     date: '2024',
        //     field: 'Networking',
        //     image: 'https://images.unsplash.com/photo-1573141597928-403fcee0e056?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=667&q=80'
        // },
        // {
        //     id: 5,
        //     title: 'Japanese Language Proficiency Test - N5',
        //     details: 'Passed the Japanese Language Proficiency Test (N5 level) in 2023.',
        //     date: '2023',
        //     field: 'Language Proficiency',
        //     image: 'https://images.unsplash.com/photo-1489389944381-3471b5b30f04?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
        // },
        {
            id: 6,
            title: 'AWS Cloud Technical Essentials',
            details: 'Completed AWS Cloud Technical Essentials course on Coursera in 2023.',
            date: '2023',
            field: 'Cloud Computing',
            image: 'https://images.unsplash.com/photo-1523474253046-8cd2748b5fd2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
        }
    ]
}
